import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { DataProvider } from "./lib/DataContext";
import AuthGate from "./components/AuthGate";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Produce from "./pages/Produce";
import Forecast from "./pages/Forecast";
import Boms from "./pages/Boms";
import Items from "./pages/Items";
import Suppliers from "./pages/Suppliers";
import AuditLog from "./pages/AuditLog";
import Reconciliation from "./pages/Reconciliation";
import BulkEdit from "./pages/BulkEdit";
import ProductionPlanning from "./pages/ProductionPlanning";
import Schedule90 from "./pages/Schedule90";
import Bundles from "./pages/Bundles";
import Shopify from "./pages/Shopify";
import MasterControls from "./pages/MasterControls";
import BomGraph from "./pages/BomGraph";
import Ordering from "./pages/Ordering";
import POTemplate from "./pages/OrderTemplates";
import Schedule from "./pages/WeeklySchedule";
import OrderSuggestions from "./pages/OrderSuggestions";
import SuperAdmin from "./pages/SuperAdmin";

function App() {
  return (
    <div className="App dark">
        <BrowserRouter>
        <AuthGate>
        <DataProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/produce" element={<Produce />} />
              <Route path="/forecast" element={<Forecast />} />
              <Route path="/boms" element={<Boms />} />
              <Route path="/items" element={<Items />} />
              <Route path="/items/bulk-edit" element={<BulkEdit />} />
              <Route path="/items/bundles" element={<Bundles />} />
              <Route path="/suppliers" element={<Suppliers />} />
              <Route path="/log" element={<AuditLog />} />
              <Route path="/shopify" element={<Shopify />} />
              <Route path="/controls" element={<MasterControls />} />
              <Route path="/bom-graph" element={<BomGraph />} />
              <Route path="/ordering" element={<Ordering />} />
              <Route path="/ordering/template" element={<POTemplate />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/schedule/planning" element={<ProductionPlanning />} />
              <Route path="/schedule/90" element={<Schedule90 />} />
              <Route path="/reconciliation" element={<Reconciliation />} />
              <Route path="/ordering/suggested" element={<OrderSuggestions />} />
              <Route path="/admin/access" element={<SuperAdmin />} />
            </Route>
          </Routes>
        </DataProvider>
        </AuthGate>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
